import client from './client';

export const getDashboardAll = async () => {
  const res = await client.get('/api/dashboard/all');
  return res.data;
};

export const dismissAlert = async (index) => {
  const res = await client.post(`/api/dashboard/alerts/${index}/dismiss`);
  return res.data;
};
